import { render } from "./DynamicSelect.vue?vue&type=template&id=44466aef&scoped=true"
import script from "./DynamicSelect.vue?vue&type=script&lang=js"
export * from "./DynamicSelect.vue?vue&type=script&lang=js"

import "./DynamicSelect.vue?vue&type=style&index=0&id=44466aef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44466aef"]])

export default __exports__